module.exports = __webpack_public_path__ + "static/media/Long-Duration-Energy-Storage.4c9af2d9.svg";